import type {LocationStateFrom} from '@/types/common/Location.types';

export function getRedirectPath(from: LocationStateFrom | undefined): string | null {
	if (!from || typeof from !== 'object' || !('pathname' in from)) {
		return null;
	}

	const pathname = from.pathname;
	if (typeof pathname !== 'string') {
		return null;
	}

	// только внутренний путь приложения (защита от open redirect)
	if (!pathname.startsWith('/') || pathname.startsWith('//')) {
		return null;
	}

	return pathname;
}
